<template>
  <button
      type="button"
      :disabled="disabled"
      :class="['ui-action-button', variantClass, pillClass, { disabled }]"
      :style="sizeStyle"
      @click="$emit('click')"
  >
    <slot>{{ text }}</slot>
  </button>
</template>

<script>
export default {
  name: 'UIActionButton',
  props: {
    text:    { type: String, default: '' },
    variant: { type: String, default: 'dark' },
    pill:    { type: Boolean, default: false },
    width:   { type: [String, Number], default: null },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    variantClass() {
      return `ui-action-button--${this.variant}`
    },
    pillClass() {
      return this.pill ? 'ui-action-button--pill' : ''
    },
    sizeStyle() {
      const value = (!this.width && this.width !== 0)
          ? 'auto'
          : (typeof this.width === 'number' ? `${this.width}px` : String(this.width))
      return { '--ui-button-size': value }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@src/design/ui-design/_variables.scss';

.ui-action-button {
  @include button-action($dark, var(--ui-button-size));

  &.disabled {
    opacity: 0.5;
  }

  &--success { @include button-action($success, var(--ui-button-size)); }
  &--danger  { @include button-action($danger, var(--ui-button-size)); }
  &--cancel  { @include button-action($gray-10, var(--ui-button-size), $gray-500); }
  &--light   { @include button-action($gray-white, var(--ui-button-size), $gray-500); }
  &--info   { @include button-action($blue-50, var(--ui-button-size), $blue-500); }

  &--pill {
    padding: 0 16px;
    border-radius: 500px;
  }
}
</style>
